import React from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@shared/ui/tooltip";
import { Info } from "lucide-react";

interface StatLabelWithTooltipProps {
  label: string;
  description: string;
  className?: string; // 👈 allow custom styling
}

export const StatLabelWithTooltip: React.FC<StatLabelWithTooltipProps> = ({
  label,
  description,
  className = "flex items-center gap-1 text-sm text-gray-600",
}) => {
  return (
    <div className={className}>
      <span>{label}</span>
      <TooltipProvider delayDuration={200}>
        <Tooltip>
          <TooltipTrigger asChild>
            <Info
              size={14}
              className="text-muted-foreground cursor-pointer hover:text-gray-600"
            />
          </TooltipTrigger>
          <TooltipContent>
            <p className="max-w-xs">{description}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
};
